import ajax from "../http.js";
import { EventEmitter } from "events";
import { isError } from "util";
import axios from "axios";

import store from "@/store";

class AuthService extends EventEmitter {
  constructor() {
    super();
    this.accessToken = null;
    this.refreshToken = null;
    this.debug = true;
  }

  /**
   * Method to create new user via API: POST
   */
  createUser(user) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/Register`, {
          Email: user.Email,
          Password: user.Password,
          ConfirmPassword: user.ConfirmPassword,
          FirstName: user.FirstName,
          LastName: user.LastName,
          TelephoneNumber: user.TelephoneNumber,
          MobileNumber: user.MobileNumber,
          Organisation: user.Organisation,
          BuildingNameOrNumber: user.BuildingNameOrNumber,
          Street: user.Street,
          City: user.City,
          PostCode: user.PostCode,
          Position: user.Position,
          ReportReason: user.ReportReason,
          Title: user.Title
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }

          resolve(error.response);
        });
    });
  }

  /**
   * Method to login a user via API: POST
   */
  loginUser(user) {
    return new Promise((resolve, reject) => {
      axios({
        //not using custom instance as baseurl + headers are different
        method: "POST",
        url: `${process.env.VUE_APP_BASE_URL}/token`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        //Data has to be manually encoded due to a bug with axios: https://github.com/axios/axios/issues/1894
        data: `username=${encodeURIComponent(user.username)}&password=${encodeURIComponent(user.password)}&grant_type=password`
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error.response);
        });
    });
  }

  getUserRole() {
    return new Promise((resolve, reject) => {
      ajax.get(`${process.env.VUE_APP_BASE_URL}/api/Account/Roles`)
      .then(response => {
        window.localStorage.setItem("CWT_ROLE", response.data[0]);
        resolve(response);
      })
      .catch(error => {
        window.localStorage.setItem("CWT_ROLE", "ERROR");
        resolve(error.response);
      });
    });
  }

  sendPasswordResetEmail(email) {
    return new Promise((resolve, reject) => {
      ajax.post(`${process.env.VUE_APP_BASE_URL}/api/Account/ForgotPassword`, {Email:  email})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
      });
    });
  }

  resetPassword(data){
    return new Promise((resolve, reject) => {
      ajax.post(`${process.env.VUE_APP_BASE_URL}/api/Account/PasswordReset`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
      });
    });
  }

  isAuthenticated() {
    let token = window.localStorage.getItem("CWT_TOKEN");
    let user = window.localStorage.getItem("CWT_USER");

    if (token !== null && user !== null) {
      store.commit("LOGIN_EVENT", {
        authenticated: true,
        user: user
      });

      return true;
    }
    return false;
  }

  /**
   * Local storage utility methods
   */
  saveAccessToken(data) {
    window.localStorage.setItem("CWT_TOKEN", data.access_token);
    window.localStorage.setItem("CWT_USER", data.userName);
    window.localStorage.setItem("CWT_ACCOUNT_TYPE", data.accountType);
    window.localStorage.setItem("CWT_SHOW_PRICES", data.showPrices.toLowerCase());
    window.localStorage.setItem("CWT_TAKE_PAYMENT", data.takeOnlinePayment.toLowerCase());
    return true;
  }

  removeLocalStorage(key) {
    window.localStorage.removeItem(key);
  }
}

const authService = new AuthService();

authService.setMaxListeners(5);

export default authService;
